

































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import WizardService from '@services/Wizard'
import POISelector from './POISelector'

settings =
  name: "PointsOfInterestStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]
    components: { POISelector }

    data: ->
      setPoints: false
      pointsOptions: []

    mounted: ->
      @initializeSetPoints()

    computed:
      targetGeo: ->
        @wizard?.campaignData?.target?.geo || {}

      actionsForPOISelector: ->
        {
          select: @selectPOI,
          unselect: @unselectPOI,
          selectAll: @selectAllPOIs,
          unselectAll: @unselectAllPOIs,
          updateDistance: @updatePOIDistance,
          addCustomPOI: @wizard.addCustomPOITrigger,
        }

      optionsForPOISelector: ->
        {
          defaultDistance: @targetGeo.distance,
          campaign: @wizard.campaignData
        }

    methods:
      initializeSetPoints: ->
        { poi_list } = @targetGeo
        @setPoints = true if poi_list.length

      hiToggleSetPoints: (value) ->
        if value
          if !@setPoints
            @wizard.scrollStepToSection('#section-geo-points')
        else
          @unselectAllPOIs()

        @setPoints = value

      selectPOI: (option) ->
        @targetGeo.poi_list.push option.data
      unselectPOI: (option) ->
        @targetGeo.poi_list = @targetGeo.poi_list.filter((poi) -> poi.id isnt option.key)
      selectAllPOIs: (options) ->
        @targetGeo.poi_list = options.map((option) -> option.data)
      unselectAllPOIs: ->
        @targetGeo.poi_list = []
      updatePOIDistance: (event) ->
        @targetGeo.distance = parseInt(event.target.value)

      fetchRetailStores: (value = '') -> 
        text = value.trim()
        @pointsOptions = []
        retailStores = await RecessAPI.search 'poi', { text, per_page: 100 } 
        poiOptions = retailStores.map((r) => r)
        @pointsOptions = [...poiOptions]

export default VueOptions.vue settings
